import { useContext } from 'react';
import { ImportStakeholdersJobContext } from './context';

export default function useImportStakeholdersJobContext() {
  return useContext(ImportStakeholdersJobContext);
}
